import { iPermissionFields, PermissionLevelEnum, PermissionSection } from "./PermissionSection";
import { iLTO, LTO } from "./LTO";
import { components } from "@apiSchema";

export interface iSummaryItem {
    chainId: number;
    chainName: string;
    pastThreeMonth: number;
    pastSixMonth: number;
    pastOneYear: number;
    pastTwoYears: number;
}

export interface iFoodLtoSection {
    summary: iSummaryItem[];
    ltos: iPermissionFields & {
        data: iLTO[];
    };
    itemsCount: number;
}

export class FoodLtoSection implements iFoodLtoSection {
    static defaultData: iFoodLtoSection = {
        summary: [],
        ltos: {
            permissionLevel: PermissionLevelEnum.Full,
            hasData: true,
            data: [],
        },
        itemsCount: 0,
    };

    summary = FoodLtoSection.defaultData.summary;
    ltos = FoodLtoSection.defaultData.ltos;
    itemsCount = FoodLtoSection.defaultData.itemsCount;

    constructor(apiModel?: components["schemas"]["ProfileLtoViewModel"]) {
        if (apiModel) {
            this.mapFromApi(apiModel);
        }
    }

    setData(data: iFoodLtoSection) {
        ({
            ltos: this.ltos,
            summary: this.summary,
            itemsCount: this.itemsCount,
        } = data);
    }

    mapFromApi(apiModel: components["schemas"]["ProfileLtoViewModel"]) {
        const {
            ltos,
            summary,
            itemsCount,
        } = apiModel;

        this.setData({
            ltos: {
                permissionLevel: PermissionSection.getPermissionLevel(ltos?.permissionLevel),
                hasData: ltos?.hasData ?? false,
                data: (ltos?.data ?? []).map(i => new LTO({ apiModel: i }))
            },
            summary: (summary ?? []).map(i => ({
                chainName: i.chainName ?? '',
                chainId: i.chainId ?? 0,
                pastTwoYears: i.twoYearscount ?? 0,
                pastOneYear: i.twelveMonthcount ?? 0,
                pastSixMonth: i.sixMonthcount ?? 0,
                pastThreeMonth: i.threeMonthcount ?? 0,
            })),
            itemsCount: itemsCount ?? 0,
        });
    }
}